export const setGallery = gallery => ({
  type: "SET_GALLERY",
  gallery
});
